import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiService } from '../../../services/api/api.service';

const name = 'DASHBOARD_CHALLENGES';

export const getCurrentChallenges = createAsyncThunk(`${name}/GET_CURRENT_CHALLENGES`,
  async ({vendorId},thunkApi) => {
    try {
      const response = await ApiService.get(`/challenge/vendor/${vendorId}/challenges`);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const postChallenge = createAsyncThunk(`${name}/POST_CHALLENGE`,
  async ({vendorId, payload}, thunkApi) => {
    try {
      const response = await ApiService.post(`challenge/vendor/${vendorId}/challenge`, payload);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });


export const patchChallenge = createAsyncThunk(`${name}/PATCH_CHALLENGE`,
  async ({vendorId, challengeId, payload}, thunkApi) => {
    try {
      const response = await ApiService.post(`challenge/vendor/${vendorId}/challenge/${challengeId}/update`, payload);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

const initialState = {
  challenges: [],
  isPending: false,
};

export const dashboardChallengesSlice = createSlice({
  name,
  initialState: initialState,
  extraReducers: {
    [patchChallenge.fulfilled]: (state, action) => {
      state.isPending = false;
    },
    [patchChallenge.pending]: (state, action) => {
      state.isPending = true;
    },
    [patchChallenge.rejected]: (state, action) => {
      state.isPending = false;
    },
    [postChallenge.fulfilled]: (state, action) => {
      state.isPending = false;
    },
    [postChallenge.pending]: (state, action) => {
      state.isPending = true;
    },
    [postChallenge.rejected]: (state, action) => {
      state.isPending = false;
    },
    [getCurrentChallenges.fulfilled]: (state, action) => {
      state.challenges = action.payload;
      state.isPending = false;
    },
    [getCurrentChallenges.pending]: (state, action) => {
      state.isPending = true;
    },
    [getCurrentChallenges.rejected]: (state, action) => {
      state.isPending = false;
    },
  }
});
